export class AccountingCloseError {
  id?: number;
  version?: number;
  taskStatus: string;
  message: string;
  evidence: string;

  taskStatusId: number;
}
